import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import CardInfo from '../../../../components/CardInfo/CardInfo'
import EditAction from '../EditAction'
import { useFormik } from 'formik'
import {
    getInitialValues,
    validationSchema,
} from '../../../../forms/PrimaryLocationForm'
import DropDown from '../../../../components/DropDown/DropDown'
import CellLocation from '../../../../components/Table/components/CellLocation'
import useScreen from '../../../../hooks/useScreen'

const PrimaryLocation = ({ user, shiptos, handleSubmit }) => {
    const [isEnabledNP, setIsEnabledNP] = useState(false)
    const { isMobile } = useScreen()

    const formattedShiptos = shiptos?.map(item => {
        return {
            ...item,
            locationToShow: (
                <CellLocation
                    isInCard
                    label={item?.label}
                    address={item?.address}
                />
            ),
        }
    })

    useEffect(() => {
        // to restart the initial value if the user cancelthe edit
        if (!isEnabledNP) {
            setFieldValue('primary_location_id', user?.primary_location_id)
        }
    }, [isEnabledNP])

    const {
        getFieldProps,
        isSubmitting,
        setSubmitting,
        isValid,
        handleSubmit: onSubmitForm,
        values,
        setFieldValue,
    } = useFormik({
        validationSchema,
        initialValues: getInitialValues(user),
        onSubmit: formValues => {
            setSubmitting(true)
            handleSubmit &&
                handleSubmit(formValues).then(() => {
                    setSubmitting(false)
                    setIsEnabledNP(false)
                })
        },
    })

    const hasDIfferences =
        values?.primary_location_id !== user?.primary_location_id

    const renderForm = () => {
        return (
            <div className="w-full flex items-center justify-start">
                <div className="lg:w-128 w-full">
                    <DropDown
                        customRender={({ label, address }) => (
                            <CellLocation
                                isInCard
                                label={label}
                                address={address}
                            />
                        )}
                        {...getFieldProps('primary_location_id')}
                        data={formattedShiptos}
                        keyId="id"
                        keyToShow="locationToShow"
                        keyToFind="address"
                        setSelectedValue={selected => {
                            setFieldValue('primary_location_id', selected?.id)
                        }}
                        selected={
                            shiptos?.find(
                                s => s?.id === values?.primary_location_id,
                            ) || {}
                        }
                        name="primaryLocation"
                        placeholder="Select Primary Location"
                        label="Your current primary location is:"
                        disabled={!isEnabledNP}
                        hasError={false}
                    />
                </div>
            </div>
        )
    }

    return (
        <form onSubmit={onSubmitForm} className="w-full">
            <CardInfo
                isOverflowVisible
                title="Primary Location"
                content={renderForm()}
                titleClass={isMobile && isEnabledNP && 'w-full'}
                headerActions={[
                    <EditAction
                        setEnabled={setIsEnabledNP}
                        isValid={
                            isValid &&
                            !isSubmitting &&
                            isEnabledNP &&
                            hasDIfferences
                        }
                        key="editButton"
                    />,
                ]}
            />
        </form>
    )
}

PrimaryLocation.propTypes = {
    shiptos: PropTypes.arrayOf(PropTypes.object),
    handleSubmit: PropTypes.func,
    user: PropTypes.object,
}

export default PrimaryLocation
